module.exports = __webpack_public_path__ + "linea-basic-10.e6763f008205c55db623.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/assets/linea/fonts/linea-basic-10.ttf
// module id = ../../../../../src/assets/linea/fonts/linea-basic-10.ttf
// module chunks = styles